"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactErrorBoundary = require("react-error-boundary");

var _ErrorFallback = _interopRequireDefault(require("./ErrorFallback"));

var _usePage2 = _interopRequireDefault(require("../hooks/usePage"));

var _formatters = require("../libs/formatters");

var _useConfig3 = _interopRequireDefault(require("../hooks/useConfig"));

var _usePages3 = _interopRequireDefault(require("../hooks/usePages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var upsertMetaTag = function upsertMetaTag(_ref) {
  var name = _ref.name,
      content = _ref.content,
      property = _ref.property;

  try {
    var existing = _toConsumableArray(document.getElementsByTagName('meta')).find(function (elm) {
      return property ? elm.getAttribute('property') === property : elm.getAttribute('name') === name;
    });

    if (existing) {
      existing.content = (0, _formatters.escapeValue)(content);
    } else {
      var meta = document.createElement('meta');

      if (property) {
        meta.setAttribute('property', property);
      } else {
        meta.setAttribute('name', name);
      }

      meta.setAttribute('content', (0, _formatters.escapeValue)(content));
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  } catch (e) {}
};

var truc = function truc(str, length) {
  if ((str === null || str === void 0 ? void 0 : str.length) > length) {
    return "".concat(str.substring(0, length - 3), "...");
  }

  return str;
};

var updatePageImage = function updatePageImage() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      imagePrefix = _ref2.imagePrefix,
      _ref2$image = _ref2.image;

  _ref2$image = _ref2$image === void 0 ? {} : _ref2$image;
  var path = _ref2$image.path,
      mimeType = _ref2$image.mimeType,
      width = _ref2$image.width,
      height = _ref2$image.height;

  try {
    if (path !== null && path !== void 0 && path.length) {
      upsertMetaTag({
        property: 'og:image',
        content: "".concat(imagePrefix).concat(path)
      });
      upsertMetaTag({
        property: 'og:image:type',
        content: mimeType !== null && mimeType !== void 0 ? mimeType : 'image/jpeg'
      });
      upsertMetaTag({
        property: 'og:image:width',
        content: width !== null && width !== void 0 ? width : 300
      });
      upsertMetaTag({
        property: 'og:image:height',
        content: height !== null && height !== void 0 ? height : 300
      });
    } else {
      var existing = _toConsumableArray(document.getElementsByTagName('meta')).filter(function (elm) {
        return ['og:image', 'og:image:type', 'og:image:width', 'og:image:height'].includes(elm.getAttribute('property'));
      });

      if (existing.length) {
        existing.forEach(function (elm) {
          return document.getElementsByTagName('head')[0].removeChild(elm);
        });
      }
    }
  } catch (e) {}
};

var PageWrapper = function PageWrapper(_ref3) {
  var _usePage, _data$awyesId, _pages$typeName;

  var Page = _ref3.page,
      path = _ref3.path,
      dynamicPath = _ref3.dynamicPath,
      projection = _ref3.projection,
      resolverField = _ref3.resolverField,
      typeName = _ref3.typeName,
      NotFoundPage = _ref3.NotFoundPage;

  var _useConfig = (0, _useConfig3["default"])(),
      _useConfig2 = _slicedToArray(_useConfig, 1),
      _useConfig2$ = _useConfig2[0],
      siteTitle = _useConfig2$.siteTitle,
      imagePrefix = _useConfig2$.imagePrefix,
      canonical_prefix = _useConfig2$.canonical_prefix;

  var _usePages = (0, _usePages3["default"])(),
      _usePages2 = _slicedToArray(_usePages, 2),
      pages = _usePages2[0].pages,
      setCurrentPage = _usePages2[1].setCurrentPage;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      pageImage = _useState2[0],
      setPageImage = _useState2[1];

  var _ref4 = (_usePage = (0, _usePage2["default"])({
    path: path,
    dynamicPath: dynamicPath,
    projection: projection,
    resolverField: resolverField
  })) !== null && _usePage !== void 0 ? _usePage : {},
      _ref5 = _slicedToArray(_ref4, 2),
      _ref5$ = _ref5[0],
      url = _ref5$.url,
      params = _ref5$.params,
      optionalParams = _ref5$.optionalParams,
      data = _ref5$.data,
      complete = _ref5$.complete,
      loading = _ref5$.loading,
      error = _ref5$.error,
      request = _ref5[1].request;

  var awyesId = (_data$awyesId = data === null || data === void 0 ? void 0 : data.awyesId) !== null && _data$awyesId !== void 0 ? _data$awyesId : (0, _formatters.buildAwyesId)({
    id: pages === null || pages === void 0 ? void 0 : (_pages$typeName = pages[typeName]) === null || _pages$typeName === void 0 ? void 0 : _pages$typeName.id,
    typeName: typeName
  });
  (0, _react.useEffect)(function () {
    var fetch = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(url !== null && url !== void 0 && url.length)) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return request();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref6.apply(this, arguments);
      };
    }();

    fetch();
    window.scrollTo(0, 0);
    return function () {
      request.aborted = true;
    };
  }, [url]);
  (0, _react.useEffect)(function () {
    if (awyesId !== null && awyesId !== void 0 && awyesId.length) {
      setCurrentPage(awyesId);
    }
  }, [awyesId]);
  (0, _react.useEffect)(function () {
    if (complete) {
      var _data$title, _data$name, _data$title2;

      document.title = "".concat(siteTitle !== null && siteTitle !== void 0 ? siteTitle : '').concat(data !== null && data !== void 0 && (_data$title = data.title) !== null && _data$title !== void 0 && _data$title.length ? " - ".concat((0, _formatters.escapeValue)(data.title)) : '');
      upsertMetaTag({
        property: 'og:title',
        content: truc("".concat(data !== null && data !== void 0 && (_data$name = data.name) !== null && _data$name !== void 0 && _data$name.length ? data.name : data !== null && data !== void 0 && (_data$title2 = data.title) !== null && _data$title2 !== void 0 && _data$title2.length ? data.title : siteTitle), 35)
      });
      upsertMetaTag({
        property: 'og:type',
        content: 'website'
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.title, data === null || data === void 0 ? void 0 : data.name, complete]);
  (0, _react.useEffect)(function () {
    if (complete) {
      var _data$description, _data$description2;

      upsertMetaTag({
        name: 'description',
        content: data !== null && data !== void 0 && (_data$description = data.description) !== null && _data$description !== void 0 && _data$description.length ? data.description : ''
      });
      upsertMetaTag({
        property: 'og:description',
        content: truc(data !== null && data !== void 0 && (_data$description2 = data.description) !== null && _data$description2 !== void 0 && _data$description2.length ? data.description : '', 65)
      });
    }
  }, [data === null || data === void 0 ? void 0 : data.description, complete]);
  (0, _react.useEffect)(function () {
    setPageImage(undefined);

    try {
      if (canonical_prefix !== null && canonical_prefix !== void 0 && canonical_prefix.length) {
        var href = "".concat(canonical_prefix).concat(url !== null && url !== void 0 && url.length ? url.replace(/^\//, '') : '');

        var existing = _toConsumableArray(document.getElementsByTagName('link')).find(function (elm) {
          return elm.getAttribute('rel') === 'canonical';
        });

        if (existing) {
          if (href !== null && href !== void 0 && href.length) {
            existing.href = (0, _formatters.escapeValue)(href);
          } else {
            document.getElementsByTagName('head')[0].removeChild(existing);
          }
        } else if (href !== null && href !== void 0 && href.length) {
          var link = document.createElement('link');
          link.setAttribute('rel', 'canonical');
          link.setAttribute('href', href);
          document.getElementsByTagName('head')[0].appendChild(link);
        }
      }
    } catch (e) {}
  }, [url, canonical_prefix]);
  (0, _react.useEffect)(function () {
    updatePageImage({
      imagePrefix: imagePrefix,
      image: pageImage
    });
  }, [pageImage, imagePrefix]);
  return !loading && complete && !data && NotFoundPage ? /*#__PURE__*/_react["default"].createElement(NotFoundPage, {
    url: url,
    params: params,
    optionalParams: optionalParams
  }) : /*#__PURE__*/_react["default"].createElement(Page, {
    url: url,
    params: params,
    optionalParams: optionalParams,
    loading: loading,
    data: data,
    complete: complete,
    error: error,
    setPageImage: setPageImage
  });
};

var PageBoundary = function PageBoundary(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactErrorBoundary.ErrorBoundary, {
    FallbackComponent: props !== null && props !== void 0 && props.ErrorPage ? props.ErrorPage : _ErrorFallback["default"]
  }, /*#__PURE__*/_react["default"].createElement(PageWrapper, props));
};

var _default = PageBoundary;
exports["default"] = _default;